export const GET_ALL_EXPENSES = 'GET_ALL_EXPENSES'
export const CHANGE_OPTIONS_DATA = 'CHANGE_OPTIONS_DATA'
export const CHANGE_EXPENSE_DATA = 'CHANGE_EXPENSE_DATA'
export const CLEAR_EXPENSE_DATA = 'CLEAR_EXPENSE_DATA'
export const SET_LOADING = 'SET_LOADING'
